module.exports = __webpack_public_path__ + "static/img/braindom.6d4ac54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partnerships/braindom.png
// module id = 64UK
// module chunks = 1